import styled from 'styled-components';
import { useSettings } from "../../contexts/SettingsProvider";
import { Breakpoint, Columns as Col, Columns, MobileBreakpoint } from "../../styles/functions";
import { TypeBodyM, TypeCaptionM, TypeHeadingL, TypeHeadingM, Wrapper } from "../../styles/mixins";
import SanityContent from "./content/SanityContent";
import SanityButton from "./SanityButton";
import SanityImage from "./SanityImage";

const SanityBuyback: React.FC<any> = ({ 
  // section,
}: any) => {
  const {buyback} = useSettings();

  if(!buyback) return <></>

  return (
    <Section>
      <Image alt={buyback.image.alt || ''} image={buyback.image} layout="fill" />
      <Description>
        <Heading>
          <Title>{buyback.heading}</Title>
          <Button link={buyback.link} />
        </Heading>
        <Content>
          <Column blocks={buyback.columnLeft} layout="DEFAULT" />
          <Column blocks={buyback.columnRight} layout="DEFAULT" />
        </Content>
      </Description>
      
    </Section>
  )
}

const Section = styled.section`
  position: relative;
  display: grid;
  /* grid-gap: var(--gutter); */
  color: var(--color-background);
  background: var(--color-earth);
  margin-top: var(--spacing-80);
  min-height: 700px;
  
  ${Breakpoint('mobile', 'min')} {
    grid-template-columns: 1fr 1fr;
    min-height: calc(
      (100 * var(--1vh)) 
      - var(--header-height) 
      - var(--spacing-24)
    );
  }

`

const Image = styled(SanityImage)`
  ${MobileBreakpoint} {
    height: 400px;
  }
`

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  margin-bottom: auto;

  ${MobileBreakpoint} {
    height: 400px;
    position: absolute;
    left:0;right:0;
    top:0;
  }
`

const Title = styled.h2`
  ${TypeHeadingM};
  text-align: center;
  ${MobileBreakpoint} {
    margin-top: auto;
  }
`

const Button = styled(SanityButton)`
  margin: 36px auto 0;
  --ButtonPrimary-background: var(--color-white);
  --ButtonPrimary-border: var(--color-white);
  --ButtonPrimary-color: var(--color-earth);

  --ButtonPrimary-hover-background: transparent;
  --ButtonPrimary-hover-border: var(--color-white);
  --ButtonPrimary-hover-color: var(--color-white);
  ${MobileBreakpoint} {
    margin-bottom: auto;
  }
`

const Description = styled.div`
  display: flex;
  /* justify-content: space-around; */
  flex-direction: column;
`

const Content = styled.div`
  ${TypeCaptionM}
  display: grid;
  grid-gap: var(--gutter);
  margin: var(--spacing-16) 16px var(--spacing-24);
  grid-template-columns: 1fr 1fr;
`

const Column = styled(SanityContent)`
  >* + * {
    margin-top: 1em;
  }

  ul {
    counter-reset: list;
    li {
      &:before {
        content: counter(list, upper-alpha);
        display: inline-flex;
        position: absolute;
        left:-40px;
        top:0;
      }
      position: relative;
      counter-increment: list;
      margin-left: 40px;

      + li {
        margin-top: 0.5em;
      }
    }
  }
`

export default SanityBuyback
